// extracted by mini-css-extract-plugin
module.exports = {"colorPickerContainer":"WorkingAreaDialog_colorPickerContainer__18Yv2","colorBox":"WorkingAreaDialog_colorBox__3Y3Zf"};